import type { FaireProductEntity } from "../../entity_types/product";

export const p_8s6cut6r8b: FaireProductEntity = {
  token: "p_8s6cut6r8b",
  type: "product",
  name: "Kids Socks That Protect Butterflies | Organic Cotton Socks",
  brandToken: "b_4fnic10q",
  brandName: "Conscious Step",
  imageUrl:
    "https://cdn.faire.com/fastly/a844a8dee05a664fb9eefecb3cb11203ccad5919bbe2ccfdacbc18c36bc33f26.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6be93fb873a138f0b21bf21aaa4bd5da0702fc5f82e11960dd784b3c42abec41.jpeg",
    "https://cdn.faire.com/fastly/b3e10121d11fc85f52fc0d95457700945fa862d286f1f1a8010babeece38e583.jpeg",
    "https://cdn.faire.com/fastly/ff5f94572c92b697eab9da958cd8272edd5a40c20c97ea2cffdd84ac2f35a86f.jpeg",
    "https://cdn.faire.com/fastly/8e8c1267fdb11b1faf16d87f9bdcc1be943d6220986161e9adaad427ad6e3beb.jpeg",
    "https://cdn.faire.com/fastly/22a3a3592d4bbe3250afe823265dec8f57cf14bc29f789a0ffa42481b3477e5c.jpeg",
    "https://cdn.faire.com/fastly/91ced6fcfb30e138f256e3f7e89eef18e79bf8802e89dd50cce33a622dd98027.jpeg",
    "https://cdn.faire.com/fastly/23474dc40422a93c9d286d827c06a9d27c9f18fe1eff25fd82532c22cc395adb.jpeg",
    "https://cdn.faire.com/fastly/5ee4fba8629f0b0425d195dfec566213257aaa311a628d1a506416db102b5969.jpeg",
    "https://cdn.faire.com/fastly/0753fed2dcb2cf869a9546bc465ef0516d859b93242664eeef7b64494497ae4e.jpeg",
    "https://cdn.faire.com/fastly/4b6eba71323797dd33f12399b236d76f687a357377176e0b872c1546915b9f2b.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "Our butterfly socks are perfect for kids who love to spread their wings and explore! Designed with bright butterflies and a cozy fit, these fluttery fun socks are ready for any and all backyard adventures.\n\n• Each sale of this pair donates to Pollinator Partnership, supporting their mission to build habitat and awareness for pollinators which are critical to food security as well as human and planetary health.\n• Certified Organic (GOTS) and Certified Fairtrade (Fairtrade International).\n• Knit with combed cotton yarn for a smooth feel, greater durability, and reduced pilling. Terry padding on the footbed for extra comfort.\n• Toddler (1-3Y) fits kids shoe sizes 3-7k. Preschool (4-6Y) fits kids shoe sizes 9-13k. Youth (7-10Y) fits kids shoe sizes 2-5.\n• Toddler pair has silicone grippers for sliding.\n• Best for: kids stores, florists, garden centers, arboretum and garden gift shops, Fairtrade stores, and retailers looking for sustainable apparel.\n• They’re a thoughtful gift that gives back for gardeners and nature lovers, and are the perfect accessory for sustainable consumers or anyone who loves fun socks.",
  tags: [],
  msrpDollars: 10.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:39.744Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
